
  export const CUSTOMERMILESTONES_RECEIVED = "CUSTOMERMILESTONES_RECEIVED";
  export const SET_CUSTOMERMILESTONE = "SET_CUSTOMERMILESTONE";
  export const CREATE_CUSTOMERMILESTONE = "CREATE_CUSTOMERMILESTONE";
  export const SET_PROPERTY_CUSTOMERMILESTONE = "SET_PROPERTY_CUSTOMERMILESTONE";
  